import React from 'react';
import FormField from '@src/components/Form/FormField';
import {ITechOperationModel} from '@src/@interfaces/models/TechOperation/ITechOperationModel';

export default function TechOperationItemDescriptionField(props: { name: string }) {
    return <FormField<ITechOperationModel>
            id={props.name}
            formName="base-option-edit-form"
            fieldLabel="TechOperationsShow.fields.description"
            type="textarea"
            fieldName={props.name}
            config={{
                label: 'TechOperationsShow.fields.description'
            }}
    />;
}
